import { createUserWithEmailAndPassword, sendEmailVerification, signInWithEmailAndPassword } from "@firebase/auth";
import { auth } from "./firebase";
// http://ec2-18-220-202-10.us-east-2.compute.amazonaws.com/docs

// const API_URL =  "http://ec2-18-220-202-10.us-east-2.compute.amazonaws.com";
const API_URL = process.env.REACT_APP_API_URL

const mapTier = (subscription_level) => {
  if (!subscription_level) return 'guest';
  if (subscription_level === 'pro') return 'pro';
  return 'signup';
};

class RecoverApiClient {
  constructor() {
    this.baseUrl = API_URL;
    this.accessToken = null;
    this.usStatesGeoJsonCache = null;
    this.usCountiesGeoJsonCache = null;
  }

  async setAccessToken(token) {
    this.accessToken = token;
    localStorage.setItem('access_token', token);
  }

  async logout() {
    this.accessToken = null;
    localStorage.removeItem('access_token');
    localStorage.removeItem('uid');
    localStorage.removeItem('user_tier');
  }
  async makeRequest(method, endpoint, data = null, params = null) {
    const url = new URL(`${this.baseUrl}${endpoint}`);

    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    const headers = {
      'Accept': 'application/json',
      ...(data && !(data instanceof FormData) ? { 'Content-Type': 'application/json' } : {})
    };

    const token = this.accessToken || localStorage.getItem('access_token');
    if (token) {
      headers['Authorization'] = `${token}`;
    }

    const options = {
      method,
      headers,
      body: data instanceof FormData ? data : (data ? JSON.stringify(data) : null)
    };

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        let errorBody = null;
        let message = `Request failed with status ${response.status}`;

        try {
          errorBody = await response.json();
          message = errorBody.detail || errorBody.message || message;
        } catch (_) {
          // fallback in case response isn't JSON
        }

        const error = new Error(message);
        error.status = response.status;
        error.body = errorBody;
        throw error;
      }

      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error; // error includes .status and .body
    }
  }


  async request(endpoint, options = {}) {
    return this.makeRequest(options.method || 'GET', endpoint, options.body, options.params);
  }

  async loginWithToken(token, email = null) {
    try {
      console.log('Login with token, email:', email);

      // If email is not provided, try to get it from the current user
      if (!email && auth.currentUser) {
        email = auth.currentUser.email;
      }

      // Call the same login endpoint but with the provided token
      const response = await this.makeRequest('POST', '/login', {
        token: token,
        email: email
      });

      await this.setAccessToken(response.access_token);
      // Store user tier in localStorage
      const tier = mapTier(response.subscription_level);
      localStorage.setItem('user_tier',tier);

      return response;
    } catch (error) {
      console.error('Login with token error:', error);
      throw error;
    }
  }

  // Auth methods
  async login(email, password) {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);


      const firebaseToken = await userCredential.user.getIdToken();

      console.log('Firebase token:', firebaseToken);
      console.log('Authenticated email:', userCredential.user.email);
      const token = await userCredential.user.getIdToken();
      console.log("Firebase Token:", token);

      const response = await this.makeRequest('POST', '/login', {
        token: firebaseToken,
        email: userCredential.user.email
      });
      console.log('Login response:', response);
      await this.setAccessToken(response.access_token);
      
      const tier = mapTier(response.subscription_level);
      localStorage.setItem('user_tier',tier);
      return response;
    } catch (error) {
      console.error('Login error:', error);
      throw error; // Make sure to re-throw so the calling code can handle it
    }
  }

  async register(data) {
    const response2 = await this.makeRequest('POST', '/user/signup', {
      ...data
    });

    return { ...response2 };
  }

  // User Endpoints
  async getUserDetails() {
    return this.makeRequest('GET', '/my_details');
  }

  async updateUserDetails(details) {
    return this.makeRequest('POST', '/user/user_details/', details);

  }
  async saveUserDetails(userData) {
    return this.updateUserDetails(userData);
    console.log(userData);
  }

  // Company Endpoints
  async listCompanies() {
    return this.makeRequest('GET', '/company/list');
  }

  async getCompanyList() {
    return this.listCompanies();
  }


  // Prediction Endpoints
  async makeFuturePrediction(stateId, startDate, endDate, timeZone) {
    const payload = {
      state_id: stateId,
      start_date: startDate,
      end_date: endDate,
      timezone: timeZone
    };

    console.log("Sending prediction request with payload:", payload);

    return this.makeRequest(
      'POST',
      '/future_prediction',
      payload,
      {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    );
  }

  async makePastPrediction(stateId, startDate, endDate, timeZone) {
    const payload = {
      state_id: stateId,
      start_date: startDate,
      end_date: endDate,
      timezone: timeZone
    };

    console.log("Sending prediction request with payload:", payload);

    return this.makeRequest(
      'POST',
      '/past_prediction',
      payload,
      {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    );
  }

  async getUsPredictionNoLogin(startDate, endDate, timeZone) {
    const payload = {
      start_date: startDate,
      end_date: endDate,
      timezone: timeZone
    };

    console.log("Sending no-login US prediction request with payload:", payload);

    return this.makeRequest(
      'POST',
      '/us_prediction_no_login',
      payload,
      {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    );
  }

  async getUsPredictionLogin(startDate, endDate, timeZone) {
  const payload = {
    start_date: startDate,
    end_date: endDate,
    timezone: timeZone
  };

  return this.makeRequest(
    'POST',
    '/us_prediction_login',
    payload,
    {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  );
}

  async getDurationPrediction(stateId, startDate, endDate, timeZone) {
    const payload = {
      state_id: stateId,
      start_date: startDate,
      end_date: endDate,
      timezone: timeZone
    };

    console.log("Sending duration prediction request with payload:", payload);

    return this.makeRequest(
      'POST',
      '/duration/',
      payload,
      {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    );
  }


  // Map Data Endpoints
  async getGeoJson(stateId) {
    // US-level view uses Plotly's built-in geometry, no GeoJSON needed
    if (!stateId || stateId === 'US') {
      return { type: "FeatureCollection", features: [] };
    }

    // Drill Down: State Map -> Return Counties for that State (From Local File)
    // We fetch the specific high-res state file from public/state_files/county_geojson/
    const formattedStateId = stateId.toString().padStart(2, '0');
    console.log(`Fetching local GeoJSON for state ${formattedStateId}...`);
    try {
      const response = await fetch(`/state_files/county_geojson/${formattedStateId}.geojson`);
      if (!response.ok) {
        throw new Error(`Local file not found: ${response.statusText}`);
      }
      return await response.json();
    } catch (e) {
      console.error(`Failed to fetch local GeoJSON for state ${stateId}, falling back to filtering US file`, e);
      // Fallback or return empty

      // Existing fallback logic (fetch big file)
      if (!this.usCountiesGeoJsonCache) {
        try {
          const response = await fetch('https://raw.githubusercontent.com/plotly/datasets/master/geojson-counties-fips.json');
          this.usCountiesGeoJsonCache = await response.json();
        } catch (err) {
          return { type: "FeatureCollection", features: [] };
        }
      }

      const filteredFeatures = this.usCountiesGeoJsonCache.features.filter(f =>
        f.properties.GEOID ? f.properties.GEOID.startsWith(stateId) : false
      );
      return { type: "FeatureCollection", features: filteredFeatures };
    }
  }

  // Weather Endpoints
  async getWeatherSummary(date, timeZone, countyId) {
    console.log('Fetching weather summary for date:', date, 'timeZone:', timeZone, 'countyId:', countyId);
    const response = await this.makeRequest('POST', '/weather/summary', {
      date: date,
      timezone: timeZone,
      county_id: countyId
    });

    const roundedResponse = Object.fromEntries(
      Object.entries(response).map(([key, { value, unit }]) => [
        key,
        {
          value: typeof value === 'number' ? Math.round(value * 100) / 100 : value,
          unit
        }
      ])
    );

    return roundedResponse;
  }


  async getHourlyWeather(date, timeZone, weatherParam, countyId) {
    return this.makeRequest('POST', '/weather/hourly', {
      date: date,
      timezone: timeZone,
      weather_param: weatherParam,
      county_id: countyId
    });
  }

  async listCounties() {
    return this.makeRequest('GET', '/county/list');
  }


  async listStates() {
    return this.makeRequest('GET', '/state/list');
  }

  // Utility Endpoints
  async listUtilities() {
    return this.makeRequest('GET', '/utility/');
  }

  async getUtilityDetails(utilityId) {
    return this.makeRequest('GET', `/utility/${utilityId}`);
  }

  async getUtilityPredictions(utilityId, startDate, endDate, timezone) {
    return this.makeRequest('POST', `/utility/${utilityId}/predictions`, {
      start_date: startDate,
      end_date: endDate,
      timezone: timezone
    });
  }

  async getUsageDetails() {
    return this.makeRequest('GET', '/user/usage_details');
  }



  async isAuthenticated() {
    const token = this.accessToken || localStorage.getItem('access_token');
    if (!token) {
      return {
        is_authenticated: false,
        is_info: false,
        is_verified: false,
        user_id: null,
        subscription_level: null
      };
    }

    try {
      const response = await this.makeRequest('GET', '/is_authenticated');
      return {
        is_authenticated: response.is_authenticated,
        is_info: response.is_info,
        is_verified: response.is_verified,
        user_id: response.user_id,
        subscription_level: response.subscription_level ?? response.user_tier ?? null
      };
    } catch (error) {
      console.error('Authentication check failed:', error);
      return {
        is_authenticated: false,
        is_info: false,
        is_verified: false,
        user_id: null,
        subscription_level: null
      };
    }
  }

  async getUsage() {
    try {
      const response = await this.makeRequest('GET', '/usage/');
      return {
        id: response.id,
        user_id: response.user_id,
        prediction_today: response.prediction_today,
        prediction_tomorrow: response.prediction_tomorrow
      };
    } catch (error) {
      console.error('Failed to get usage statistics:', error);
      throw error;
    }
  }

  // News Endpoints
  async getTopNews() {
    try {
      const response = await this.makeRequest('GET', '/nws/top');
      return response;
    } catch (error) {
      console.error('Failed to get top news:', error);
      throw error;
    }
  }

  // Blob request method for binary responses (e.g. PDF)
  async makeBlobRequest(method, endpoint, params = null) {
    const url = new URL(`${this.baseUrl}${endpoint}`);

    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    const token = this.accessToken || localStorage.getItem('access_token');
    const headers = { 'Accept': 'application/pdf' };
    if (token) {
      headers['Authorization'] = token;
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 360_000);

    try {
      const response = await fetch(url, { method, headers, signal: controller.signal });

      if (!response.ok) {
        let errorBody = null;
        let message = `Request failed with status ${response.status}`;

        try {
          errorBody = await response.json();
          message = errorBody.detail || errorBody.message || message;
        } catch (_) {
          // non-JSON error body — keep default message
        }

        const error = new Error(message);
        error.status = response.status;
        error.body = errorBody;
        throw error;
      }

      return response.blob();
    } finally {
      clearTimeout(timeoutId);
    }
  }

  // FEMA Report Endpoints
  async generateFEMAReport(femaRegion, scenario) {
    return this.makeRequest('GET', '/report/fema/generate', null, {
      region: femaRegion,
      scenario: scenario
    });
  }

  async getFEMARegions() {
    return this.makeRequest('GET', '/pdf_subscription/regions');
  }

  async savePdfSubscription(payload) {
    return this.makeRequest('POST', '/pdf_subscription/mapping', payload);
  }

  async getPdfSubscriptionMapping() {
    return this.makeRequest('GET', '/pdf_subscription/mapping');
  }

  async addPdfSubscription(payload) {
    return this.makeRequest('POST', '/pdf_subscription/mapping/add', payload);
  }

  async updatePdfSubscription(regionId, payload) {
    return this.makeRequest('PUT', `/pdf_subscription/mapping/${regionId}/status`, payload);
  }

  async deletePdfSubscription(regionId) {
    return this.makeRequest('DELETE', `/pdf_subscription/mapping/${regionId}`);
  }

}

// Initialize the API client
const apiClient = new RecoverApiClient();

export default apiClient;
